var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1563 22.9062L21.6562 23.9375C21.625 24.1563 21.5313 24.3906 21.3906 24.5781C21.125 24.9844 20.7188 25.2812 20.25 25.4062C19.7812 25.5156 19.2813 25.4375 18.875 25.1562L15 22.6875C14.8125 22.5781 14.7813 22.3594 14.8906 22.1875C15 22.0156 15.2187 21.9687 15.375 22.0781L19.2656 24.5469C19.7812 24.8594 20.4531 24.7187 20.7813 24.2187C21.1094 23.7187 20.9531 23.0312 20.4531 22.7031L15.6094 19.6406C14.8125 19.1406 13.8906 18.75 13.0156 19.1875L9 21.4688V26.0625L11.875 23.9219C12.3281 23.8125 12.8281 23.9063 13.25 24.1719L16.625 26.2969C17.4531 26.8125 18.4687 26.9375 19.3437 26.7031L26.6562 25.0313C27.2344 24.9063 27.625 24.3281 27.4844 23.7031C27.3281 23.1406 26.75 22.7812 26.1563 22.9062ZM22.9688 11.5469C20.125 11.5469 17.8281 13.8437 17.8281 16.6875C17.8281 19.5312 20.125 21.8281 22.9688 21.8281C25.8125 21.8281 28.1094 19.5312 28.1094 16.6875C28.1094 13.8437 25.7969 11.5469 22.9688 11.5469ZM25.8906 14.7812L22.3594 19.6562L20.0938 17.2031C19.8437 16.9219 19.8594 16.5 20.125 16.2344C20.4062 15.9844 20.8281 16 21.0938 16.2656L22.2344 17.5L24.7812 13.9844C25 13.6875 25.4219 13.6094 25.7344 13.8281C26.0312 14.0469 26.1094 14.4844 25.8906 14.7812Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon16.77c354ac092e34e703a358e19abe102f.svg";
export { ForwardRef as ReactComponent };